import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (!value) return null;

    const phoneRegex = /^(\+|00)?[0-9 .\(\)\-]{3,20}$/;

    if (phoneRegex.test(value)) return null;

    return {
      phone: true,
    };
  };
}
